module.exports = {"id":"208022","name":"Imoh Ezekiel","rating":"74","photo":"./data/images/photos/0/208022.png","club":{"name":"UD Las Palmas","logo":"./data/images/clubs/UDLasPalmas.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ImohEzekiel0.json
// module id = 1803
// module chunks = 0